import { useDialogPortal, useTransactionFees, useGasEstimation, useTransactionExecution } from "@/hooks";
import { claimEventEmitter, CLAIM_EVENTS } from "@/events";
import { prepareClaimTransaction, estimateClaimTransactionGas, gatewayClaimTransaction } from "@/services";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/config";
import { useAccount } from "wagmi";

export function useClaimRedemptionTransaction() {
    const { closeDialog } = useDialogPortal();
    const { address } = useAccount();

    const {
        gasEstimate,
        isEstimatingGas,
        error: gasError,
    } = useGasEstimation({
        estimateGasFn: (walletClient) => estimateClaimTransactionGas(walletClient),
        prepareTransactionFn: async (walletClient) => {
            return prepareClaimTransaction(walletClient);
        },
        hasApproval: true,
    });

    const { gasPriceUSD } = useTransactionFees({
        estimatedGas: gasEstimate,
    });

    const { invalidateQueries } = useQueryClient();

    const {
        transactionHash,
        isExecuting,
        error: transactionError,
        executeTransaction: executeClaimTransaction,
    } = useTransactionExecution({
        executeTransactionFn: (walletClient) => gatewayClaimTransaction(walletClient),
        onSuccess: (hash) => {
            claimEventEmitter.emit(CLAIM_EVENTS.SUCCESS, {
                transactionHash: hash,
                claimAmount: 0, // TODO @jon - this one is on you
            });
            closeDialog();
            invalidateQueries({
                queryKey: QUERY_KEYS.TOKENS.BALANCE.LIST(address),
            });
            invalidateQueries({
                queryKey: QUERY_KEYS.REDEMPTIONS.USER(address ?? ""),
            });
        },
        errorMessage: "Failed to cancel exit",
    });

    return {
        gasPriceUSD,
        transactionHash,
        executeClaimTransaction,
        isLoading: isExecuting,
        isEstimatingGas,
        error: gasError || transactionError,
        gasEstimate,
    };
}
